export default __webpack_public_path__ + "static/feature-adapter-548474370edc22330dabef385a0df0a2.png";